import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { Button, createForm, DescriptionList, Dialog, Flex, GridAlpha, Heading, Notice, Text, TextInput, useToasts } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { CheckMarkOutlineIcon, CloseOutlineIcon, DocumentCheckOutlineIcon, SearchOutlineIcon } from '@applyboard/ui-icons';
import { assert } from "../../../../../utils/assert";
import { useApplicationStudent } from "../../../data/student";
import { useVerifyIelts } from "../../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
export function IeltsVerificationButton() {
  var _student$profile$test, _student$profile$pers;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useVerifyIelts = useVerifyIelts(),
    verifiedIelts = _useVerifyIelts.verifiedIelts,
    verifyIelts = _useVerifyIelts.verifyIelts,
    verifyIeltsStatus = _useVerifyIelts.verifyIeltsStatus;
  var toasts = useToasts();
  var _useTranslation = useTranslation('ExamDetails'),
    t = _useTranslation.t;
  var _useApplicationStuden = useApplicationStudent(),
    student = _useApplicationStuden.student;
  var ielts = (_student$profile$test = student.profile.testScores) === null || _student$profile$test === void 0 ? void 0 : _student$profile$test.ielts;
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    trfNumber = _useState4[0],
    setTrfNumber = _useState4[1];
  assert(ielts, 'Could not find IELTS test score on student profile');
  var studentProfileName = getFormattedName({
    firstName: student.profile.personalInformation.firstName,
    lastName: student.profile.personalInformation.lastName
  });
  var verifiedIeltsName = getFormattedName({
    firstName: verifiedIelts === null || verifiedIelts === void 0 ? void 0 : verifiedIelts.firstName,
    lastName: verifiedIelts === null || verifiedIelts === void 0 ? void 0 : verifiedIelts.familyName
  });
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    size: "lg",
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        leadIcon: DocumentCheckOutlineIcon,
        intent: "primary",
        emphasis: "outlined",
        children: t('ieltsDialog.button')
      })
    }), _jsx(Dialog.Heading, {
      children: t('ieltsDialog.heading')
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(Form, {
          defaultValues: {
            trfNumber: (ielts === null || ielts === void 0 ? void 0 : ielts.referenceNumber) || trfNumber
          },
          onSubmit: function onSubmit(values) {
            verifyIelts({
              studentId: student.profile.studentId,
              trfNumber: values.trfNumber
            }, {
              onSuccess: function onSuccess() {
                setTrfNumber(values.trfNumber);
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                }
              }
            });
          },
          children: _jsxs(Flex, {
            gap: 2,
            children: [_jsx(Flex.Item, {
              grow: 1,
              children: _jsx(Field, {
                name: "trfNumber",
                as: TextInput,
                label: t('ieltsDialog.ieltsTrfNumber'),
                required: t('ieltsDialog.requiredError')
              })
            }), _jsx("div", {
              css: function css(_ref) {
                var spacing = _ref.spacing;
                return {
                  paddingTop: "calc(1.5rem + ".concat(spacing[2], ")")
                };
              },
              children: _jsx(Button, {
                type: "submit",
                leadIcon: SearchOutlineIcon,
                intent: "primary",
                "aria-label": t('ieltsDialog.search'),
                loading: verifyIeltsStatus === 'loading'
              })
            })]
          })
        }), verifiedIelts && _jsxs(Flex, {
          direction: "column",
          gap: 2,
          children: [_jsx(Notice, {
            intent: "positive",
            children: verifiedIelts.source === 'ielts_web_service' ? t('ieltsDialog.comparedIelts') : t('ieltsDialog.verifiedIelts')
          }), verifiedIelts.testResults.trfNumber.endsWith('G') && _jsx(Notice, {
            intent: "warning",
            children: t('ieltsDialog.warningGeneral')
          }), checkIfExamExpired(verifiedIelts.testResults.dateOfExamination) && _jsx(Notice, {
            intent: "warning",
            children: t('ieltsDialog.warningExamDate')
          }), _jsx(Heading, {
            id: "ieltsTestDetails",
            level: 3,
            variant: "labelL",
            children: t('ieltsDialog.testDetails')
          }), _jsxs(Flex, {
            gap: 4,
            justify: "between",
            children: [_jsx(DescriptionList, {
              variant: "free",
              "aria-labelledby": "ieltsTestDetails",
              children: _jsxs(GridAlpha, {
                columns: "180px 1fr",
                columnGap: 4,
                rowGap: 2,
                children: [_jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.id')
                }), _jsx(DescriptionList.Details, {
                  children: verifiedIelts.candidateId
                }), _jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.number')
                }), _jsx(DescriptionList.Details, {
                  children: verifiedIelts.candidateNumber
                }), _jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.center')
                }), _jsx(DescriptionList.Details, {
                  children: verifiedIelts.centerName
                }), _jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.name')
                }), _jsx(VerifiedDetail, {
                  baselineValue: studentProfileName,
                  comparisonValue: verifiedIeltsName
                }), _jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.birthdate')
                }), _jsx(VerifiedDetail, {
                  baselineValue: student.profile.personalInformation.birthdate,
                  comparisonValue: verifiedIelts.dateOfBirth
                }), _jsx(DescriptionList.Term, {
                  children: t('ieltsDialog.gender')
                }), _jsx(VerifiedDetail, {
                  baselineValue: (_student$profile$pers = student.profile.personalInformation.gender) === null || _student$profile$pers === void 0 ? void 0 : _student$profile$pers[0].toUpperCase(),
                  comparisonValue: verifiedIelts.sex.toUpperCase()
                })]
              })
            }), verifiedIelts.image && _jsx(Flex.Item, {
              children: _jsx("img", {
                src: verifiedIelts.image,
                alt: "Portrait of ".concat(verifiedIeltsName)
              })
            })]
          }), _jsx(Heading, {
            id: "ieltsTestResults",
            level: 3,
            variant: "labelL",
            children: t('ieltsDialog.testResults')
          }), _jsx(DescriptionList, {
            variant: "free",
            "aria-labelledby": "ieltsTestResults",
            children: _jsxs(GridAlpha, {
              columns: "180px 1fr",
              columnGap: 4,
              rowGap: 2,
              children: [_jsx(DescriptionList.Term, {
                children: t('ieltsDialog.examDate')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.examDate,
                comparisonValue: verifiedIelts.testResults.dateOfExamination
              }), _jsx(DescriptionList.Term, {
                children: t('ieltsDialog.listening')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.listening,
                comparisonValue: verifiedIelts.testResults.listening
              }), _jsx(DescriptionList.Term, {
                children: t('ieltsDialog.reading')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.reading,
                comparisonValue: verifiedIelts.testResults.reading
              }), _jsx(DescriptionList.Term, {
                children: t('ieltsDialog.writing')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.writing,
                comparisonValue: verifiedIelts.testResults.writing
              }), _jsx(DescriptionList.Term, {
                children: t('ieltsDialog.speaking')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.speaking,
                comparisonValue: verifiedIelts.testResults.speaking
              }), _jsx(DescriptionList.Term, {
                children: t('ieltsDialog.overall')
              }), _jsx(VerifiedDetail, {
                baselineValue: ielts.average,
                comparisonValue: verifiedIelts.testResults.overallBand
              })]
            })
          })]
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Flex, {
        justify: "end",
        grow: 1,
        children: _jsx(Dialog.CloseButton, {
          children: t('ieltsDialog.cancel')
        })
      })
    })]
  });
}
function VerifiedDetail(_ref2) {
  var baselineValue = _ref2.baselineValue,
    comparisonValue = _ref2.comparisonValue;
  var _useTranslation2 = useTranslation('ExamDetails'),
    t = _useTranslation2.t;
  var isConsistent = baselineValue === comparisonValue;
  return _jsx(DescriptionList.Details, {
    children: _jsxs(Flex, {
      direction: "column",
      gap: 1,
      children: [_jsxs(Flex, {
        gap: 1,
        children: [isConsistent ? _jsx(CheckMarkOutlineIcon, {
          intent: "positive"
        }) : _jsx(CloseOutlineIcon, {
          intent: "negative"
        }), _jsx(Text, {
          intent: isConsistent ? 'positive' : 'negative',
          children: comparisonValue || '--'
        })]
      }), !isConsistent && _jsx(Text, {
        contrast: "mid",
        variant: "bodyS",
        children: t('ieltsDialog.onApplyboard', {
          baselineValue: baselineValue || '--'
        })
      })]
    })
  });
}
function checkIfExamExpired(testDate) {
  if (!testDate) {
    return;
  }
  var twoYearsAgo = new Date();
  twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
  return !!(testDate && new Date(testDate) < twoYearsAgo);
}
function getFormattedName(_ref3) {
  var firstName = _ref3.firstName,
    lastName = _ref3.lastName;
  return "".concat(processBlankName(firstName), " ").concat(processBlankName(lastName)).trim();
}
function processBlankName(name) {
  if (!name || name === '.' || name === '-') {
    return '';
  }
  return name;
}